import React from "react";

import Page from "../../../../components/Page";
import Header from "../../../../components/Header";
import PageHeaderBanner from "../../../../sections/layouts/pageHeaderBanner";
import VideoSection from "../../../../sections/layouts/videoSection";
import Section from "../../../../sections/layouts/section";
import SplitColumn from "../../../../sections/layouts/splitColumn";
import Footer from "../../../../components/Footer";
import Custom_a from "../../../../sections/layouts/custom_a";
import Image from "../../../../components/Image";
import VerticalTickBox from "../../../../sections/layouts/verticalTickBox";

import tipping_video_image from "../images/tabletpos/video_thumbnail_tipping.jpg";
import tabletPos_banner from "../images/tabletpos/image_insert_tabletpos.jpg";
import tabletPos_stand from "../images/tabletpos/stand.png";

import tabletPosLogo from "../images/tabletpos/logo_tabletpos@2x.png";
import YocoMerchant from "../yocoMerchant";
import truth_avatar from "../images/tabletpos/avatar_truth.png";
import wing_republic_avatar from "../images/tabletpos/avatar__wing-republic.png";
import grind_avatar from "../images/tabletpos/avatar_grind.png";
import SEOInfo from "../../../../components/SEOInfo";
import ColumnInfoBox from "../../../../sections/layouts/columnInfoBox";

const headerBannerProps = {
  pageSubheader: "Yoco + TabletPOS",
  textColor: "black",
  bgColor: "#f6f6f6",
  pageText: (
    <p>Scale your hospitality business with Yoco Payments and TabletPOS.</p>
  )
};

const tickBox = [
  ["Table of orders", "Checkout", "Checking in", "Receipt printing"],
  [
    "Integrated payment",
    "Table management",
    "Inventory management",
    "Financial reporting"
  ]
];

const costInfo = [
  {
    heading: "Increase the table turnover",
    paragraph:
      "With small affordable card readers every waitron can carry their own and close their tables faster."
  },
  {
    heading: "Cash up in minutes",
    paragraph:
      "Forget about counting paper clips. All the information you need is now in iKentoo."
  },
  {
    heading: `Reduce Risk`,
    paragraph:
      "Tables in iKentoo only close once the Yoco payment is confirmed, reducing your risk of loss."
  },
  {
    heading: `Collect more tips`,
    paragraph:
      "Your staff wont lose out on tips thanks to on-device tipping and our integration gives you full reporting."
  }
];

const IndexPage = props => {
  const { location } = props;
  return (
    <Page>
      <SEOInfo
        title={"Tablet POS"}
        description={""}
        canonicalLink={location.pathname}
      />
      <Header />
      <PageHeaderBanner pageLogo={tabletPosLogo} {...headerBannerProps} />
      <Section className={"pt-4 pb-0"}>
        <div className={"container"}>
          <div className={"row"}>
            <ColumnInfoBox
              data={costInfo}
              headerStyle={{ fontWeight: "bold" }}
            />
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-12 pt-5"}>
            <img src={tabletPos_banner} alt={"could not load image"} />
          </div>
        </div>
      </Section>
      <Section textAlign="left">
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-md-7"}>
              <h2>PARTNER FEATURES</h2>
              <h3 className={"pr-0"}>
                TabletPOS is a point of sale developed for the hospitality
                industry
              </h3>
              <SplitColumn
                left={
                  <VerticalTickBox
                    data={tickBox[0]}
                    tickStyle={{ marginTop: "35px", marginLeft: "7px" }}
                  />
                }
                right={
                  <VerticalTickBox
                    data={tickBox[1]}
                    tickStyle={{ marginTop: "35px", marginLeft: "7px" }}
                  />
                }
              />
            </div>
            <div className={"col-md-5 pl-md-5"}>
              <Image src={tabletPos_stand} />
            </div>
          </div>
        </div>
      </Section>
      <Section
        header="YOCO + TABLETPOS INTEGRATION"
        subHeader="What our merchants are saying"
        bgColor="#F6F6F6"
      >
        <div className={"container"}>
          <div className={"row"}>
            <YocoMerchant
              avatar={truth_avatar}
              paragraph={
                "Yoco has changed the way we do things at Truth... Integration between our POS and Yoco has been seamless, if you don't integrate you are wasting your time."
              }
              merchantName={"DAVID DONDE"}
            />
            <YocoMerchant
              avatar={wing_republic_avatar}
              paragraph={
                "The two systems can speak to each other, so we can scan from one and print using the iKentoo system. It works phenomenally."
              }
              merchantName={"TLHOMPHO MOKOENA"}
            />
            <YocoMerchant
              avatar={grind_avatar}
              paragraph={
                "Yoco came to us when I was 6 months into trading and I wanted a system that could integrate into our point of sale, that would allow me to control from the purchase to stock."
              }
              merchantName={"DAYNE LAVINRAD"}
            />
          </div>
        </div>
      </Section>
      <VideoSection
        header={["HOW TO VIDEO"]}
        subHeader={["Staff tipping"]}
        paragraph={[
          "Customers can enter a tip right on the Yoco card machine. It's so simple we've seen merchants have increased tip amounts of up to 400%. Merchants who use this feature can't express how much happier their staff are."
        ]}
        youtubeVideoId="kP-NyfEyAqI"
        previewImage={tipping_video_image}
        bgColor="#FFFFFF"
      />
      <Section bgColor="#DEE6E9">
        <Custom_a />
      </Section>
      <Footer />
    </Page>
  );
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/za/integrations/tabletPOS/index.js